import { useEffect } from 'react';


const usePageTitle = title => {
    useEffect(() => {
        document.title = title;

        return () => {
            document.title = 'Fudopia | Meet. Eat. Repeat.'
        }
    }, [title]);
};

export default usePageTitle;
